import { TFunction } from "i18next";
import { z, ZodIssueCode } from "zod";

interface PhoneValidationConfig {
  Start: number;
  Length: number;
}

export const createPhoneNumberSchema = (
  t: TFunction,
  validate: PhoneValidationConfig | null,
) => {
  return z.object({
    PhoneNumber: z
      .string()
      .nonempty({ message: t("phone_number_required") })
      .superRefine((value, ctx) => {
        if (!validate) {
          ctx.addIssue({
            code: ZodIssueCode.custom,
            message: t("validation_configuration_error"),
          });
          return;
        }

        // Remove any non-numeric characters
        const phoneNumber = value.replace(/[^0-9]/g, "");
        const countryStart = validate.Start.toString();
        const countryLength = validate.Length;

        // Define the valid starting sequences
        const startWith0 = `0${countryStart}`;
        const startWithCountryStart = `${countryStart}`;

        if (phoneNumber.startsWith(startWith0)) {
          if (phoneNumber.length !== countryLength + 1) {
            ctx.addIssue({
              code: ZodIssueCode.custom,
              message: t("phone_number_must_be_and_start_with", {
                length: countryLength + 1,
                start: startWith0,
              }),
            });
          }
        } else if (phoneNumber.startsWith(startWithCountryStart)) {
          if (phoneNumber.length !== countryLength) {
            ctx.addIssue({
              code: ZodIssueCode.custom,
              message: t("phone_number_must_be_and_start_with", {
                length: countryLength,
                start: startWithCountryStart,
              }),
            });
          }
        } else {
          ctx.addIssue({
            code: ZodIssueCode.custom,
            message: t("phone_number_must_start_with", {
              start1: startWithCountryStart,
              start2: startWith0,
            }),
          });
        }
      }),
  });
};
